<template>
  <div class="lotti-signin-container">
    <div class="lotti-signin-box">

      <div class="lotti-signin-logo">
        <svg width="176" height="251" viewBox="0 0 176 251" fill="none" xmlns="http://www.w3.org/2000/svg">

          <path d="M40.0563 231.148H58.7184V238.208H31.2672V195.552H40.0563V231.148ZM61.9117 222.066C61.9117 218.921 62.5172 216.119 63.7281 213.658C64.9391 211.197 66.6774 209.292 68.943 207.945C71.2281 206.597 73.8746 205.923 76.8824 205.923C81.1598 205.923 84.6461 207.232 87.3414 209.849C90.0563 212.466 91.5699 216.021 91.8824 220.513L91.941 222.681C91.941 227.544 90.5836 231.451 87.8688 234.4C85.1539 237.33 81.5114 238.794 76.941 238.794C72.3707 238.794 68.7184 237.33 65.984 234.4C63.2692 231.47 61.9117 227.486 61.9117 222.447V222.066ZM70.3785 222.681C70.3785 225.689 70.9449 227.994 72.0778 229.595C73.2106 231.177 74.8317 231.968 76.941 231.968C78.9918 231.968 80.5934 231.187 81.7457 229.625C82.8981 228.042 83.4742 225.523 83.4742 222.066C83.4742 219.117 82.8981 216.832 81.7457 215.21C80.5934 213.589 78.9723 212.779 76.8824 212.779C74.8121 212.779 73.2106 213.589 72.0778 215.21C70.9449 216.812 70.3785 219.302 70.3785 222.681ZM107.293 198.716V206.509H112.713V212.72H107.293V228.541C107.293 229.712 107.517 230.552 107.966 231.06C108.416 231.568 109.275 231.822 110.545 231.822C111.482 231.822 112.312 231.753 113.035 231.617V238.033C111.375 238.541 109.666 238.794 107.908 238.794C101.97 238.794 98.943 235.796 98.8258 229.8V212.72H94.1969V206.509H98.8258V198.716H107.293ZM127.566 198.716V206.509H132.986V212.72H127.566V228.541C127.566 229.712 127.791 230.552 128.24 231.06C128.689 231.568 129.548 231.822 130.818 231.822C131.755 231.822 132.586 231.753 133.308 231.617V238.033C131.648 238.541 129.939 238.794 128.181 238.794C122.244 238.794 119.216 235.796 119.099 229.8V212.72H114.47V206.509H119.099V198.716H127.566ZM146.638 238.208H138.142V206.509H146.638V238.208ZM137.644 198.306C137.644 197.037 138.064 195.992 138.904 195.171C139.763 194.351 140.925 193.941 142.39 193.941C143.836 193.941 144.988 194.351 145.847 195.171C146.707 195.992 147.136 197.037 147.136 198.306C147.136 199.595 146.697 200.65 145.818 201.47C144.959 202.291 143.816 202.701 142.39 202.701C140.964 202.701 139.812 202.291 138.933 201.47C138.074 200.65 137.644 199.595 137.644 198.306Z"
                fill="url(#paint0_linear)"/>

          <circle cx="88.4298" cy="88.3636" r="69.3636" fill="white"/>
          <circle cx="88.4298" cy="88.3636" r="78.4393" stroke="url(#paint1_linear)" stroke-width="18.1512"/>

          <path class="lotti-hand-minutes" style="transform-origin: center 35%;" d="M88.4297 88.3633L88.4299 38.2674" stroke="url(#paint3_linear)" stroke-width="18.1512"
                stroke-linecap="round"/>
          <path class="lotti-hand-hours" style="transform-origin: center 35%;" d="M56.831 88.1685L88.4299 88.1685" stroke="url(#paint2_linear)" stroke-width="18.1512"
                stroke-linecap="round"/>

          <defs>
            <linearGradient id="paint0_linear" x1="39.8086" y1="196.03" x2="144.702" y2="226.14"
                            gradientUnits="userSpaceOnUse">
              <stop stop-color="#865DFF"/>
              <stop offset="1" stop-color="#50BF6A"/>
            </linearGradient>
            <linearGradient id="paint1_linear" x1="32.8912" y1="42.8363" x2="140.631" y2="129.6"
                            gradientUnits="userSpaceOnUse">
              <stop stop-color="#865DFF"/>
              <stop offset="1" stop-color="#50BF6A"/>
            </linearGradient>
            <linearGradient id="paint2_linear" x1="43.5" y1="88" x2="87.9836" y2="87.1464" gradientUnits="userSpaceOnUse">
              <stop stop-color="#50BF6A"/>
              <stop offset="1" stop-color="#865DFF"/>
            </linearGradient>
            <linearGradient id="paint3_linear" x1="88.0001" y1="88" x2="97.8661" y2="31.8885"
                            gradientUnits="userSpaceOnUse">
              <stop stop-color="#50BF6A"/>
              <stop offset="1" stop-color="#865DFF"/>
            </linearGradient>
          </defs>
        </svg>

      </div>

      <div class="lotti-signin-subtitle">
        Logopädie TimeTracking
        Instrument<br>
      </div>

      <div class="lotti-signin-form">

        <el-alert v-if="error"
                  title="Fehler - Login mit diesen Zugangsdaten gescheitert!"
                  type="error"
                  show-icon>
        </el-alert>

        <el-form :rules="rules" :model="loginFormData" ref="loginForm" @keyup.enter.native="submitForm($event)">

          <el-form-item prop="email" name="email">
            <el-input placeholder="E-Mail" v-model="loginFormData.email"></el-input>
          </el-form-item>

          <el-form-item prop="password" name="password" autocomplete="off">
            <el-input type="password" placeholder="Passwort" v-model="loginFormData.password"></el-input>
          </el-form-item>

          <el-form-item>

            <el-button :loading="isLoading" type="primary" @click="submitForm($event)">Login</el-button>

            <router-link :to="{ name: 'reset-password' }" class="lotti-signin-forgotten">
              Passwort vergessen?
            </router-link>

          </el-form-item>

        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import auth from '../../auth.js';
import clockHelper from '../../Helpers/ClockHelper.js';

export default {

  data() {
    return {
      error: false,
      isLoading: false,
      loginFormData: {
        email: null,
        password: null
      },
      rules: {
        email: [
          {required: true, message: 'Bitte E-Mail eingeben', trigger: 'blur'},
          {type: 'email', message: 'Bitte eine korrekte E-Mail-Adresse eingeben', trigger: 'blur'}
        ],
        password: [
          {required: true, message: 'Bitte Passwort eingeben', trigger: 'blur'}
        ]
      },
    }
  },
  methods: {

    submitForm(event) {
      event.preventDefault();
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          auth.signin(this, this.loginFormData.email, this.loginFormData.password)
        } else {
          return false;
        }
      });
    },
  },

  mounted() {
    //exec once only on mounted, to adjust the clock initially for signin sceen
    clockHelper.setClock();
  },
}

</script>